/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component
} from '@angular/core';
import { EntityFinderDialog, EntityFinderParams, ISortModel } from '@core';


import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { UtilFns } from '@utils';
import { ColDef } from '@ag-grid-community/core';
import { AccountDbQueryService } from '../services/account-db-query.service';
import { ShippingUserGroup } from '@models';


export interface ShippingUserGroupFinderParams extends EntityFinderParams {
  shippingUserGroups: ShippingUserGroup[];
}

@Component({
    selector: 'prox-shipping-user-group-finder',
    template: EntityFinderDialog.HTML,
    standalone: false
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class ShippingUserGroupFinderDialog extends EntityFinderDialog<ShippingUserGroup, ShippingUserGroupFinderParams> {

  params: ShippingUserGroupFinderParams;
  programUserGroups: ShippingUserGroup[] = [];
  
  constructor(
    ref: DynamicDialogRef,
    config: DynamicDialogConfig<ShippingUserGroupFinderParams>,
    public dbQueryService: AccountDbQueryService,

  ) {
    super(ref, config);
    UtilFns.assert(config.data);
    this.params = config.data;
    UtilFns.assertNonNull(this.params.shippingUserGroups, 'shippingUserGroups');
  }

  override async initialize() {
    
    return {
      header: `Select Shipping User Groups`,
      width: 'calc(40vw)',
      rowModelType: 'clientSide'
    } as const;
  }

  override async initDatasource() {
    return this.params.shippingUserGroups;
    
  }

  override getColDefsAndSortModel() {
    const colDefs = [
      { headerName: 'Name', field: 'name', filter: 'agTextColumnFilter', },
    ] as ColDef[]
    const sortModel = [
      { colId: 'name', sort: 'asc' },
    ] as ISortModel
    return [ colDefs, sortModel] as const;
  }


}